import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { CalendarDTO, createCalendar } from 'src/app/interfaces/calendar';
import { CalendarService } from 'src/app/services/calendar.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { ColorPickerComponent } from "../color-picker/color-picker.component";

@Component({
  selector: 'app-calendar',
  imports: [MatCheckboxModule, FormsModule, MatLabel, MatFormFieldModule, MatDatepickerModule, MatInputModule, MatButtonModule, ColorPickerComponent],
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent {

  calendar: CalendarDTO;

  constructor(private tokenStorageService: TokenStorageService, private router: Router, public dialogRef: MatDialogRef<CalendarComponent>, @Inject(MAT_DIALOG_DATA) data,
    private calendarService: CalendarService) {
    this.calendar = data;
  }

  async save() {
    const data = await firstValueFrom(this.calendarService.saveCalendar(this.calendar.id, createCalendar(this.calendar.userId, this.calendar.calendarIntegrationId, this.calendar.externalCalendarId, this.calendar.summary, this.calendar.showInDashboard, this.calendar.showInNotes, this.calendar.uuid, this.calendar.taskUuid, this.calendar.color, this.calendar.url)));
    this.dialogRef.close({ data: data });
  }

  onColorSelect(newColor: string): void {
    this.calendar.color = newColor;
  }

}
